import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import moment from 'moment';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-news-forum',
  templateUrl: './news-forum.component.html',
  styleUrls: ['./news-forum.component.scss'],
})
export class NewsForumComponent implements OnInit {
  constructor(
    private auth: AuthServiceService,
    private modalService: ModalService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public roleService: RoleService,
    private cdr: ChangeDetectorRef
  ) {

  }

  @Input() forumId: any;

  ngOnInit(): void {
    this.initNewsByForumId()
  }

  imgUrl: string = environment.ImageUrl;


  protected news: any = []
  initNews(search?: string) {
    this.auth.get_bottom_banner({
      isPopular: 0,
      pageSize: 15,
      search: search ?? ''
    }).subscribe((response: any) => {
      this.news = response?.body?.data
      this.cdr.detectChanges();
    })
  }

  protected newsForum: any = []
  initNewsByForumId() {
    this.auth.get_news_by_forum_id(this.forumId).subscribe((response: any) => {
      this.newsForum = response?.body
      this.cdr.detectChanges();
    })
  }

  @ViewChild('modalNewsAdd') modalNewsAdd: TemplateRef<any>;
  openModalNewsAdd() {
    this.initNews()
    this.modalService.open(this.modalNewsAdd, { size: 'md' });
  }

  selectedNews: any[] = [];
  selectNews(news: any) {
    if (this.selectedNews.includes(news.id)) {
      this.selectedNews = this.selectedNews.filter((item: any) => item !== news.id);
    } else {
      this.selectedNews.push(news.id);
    }
  }

  submitNewsToForum() {
    this.auth.add_news_to_forum({
      newsIds: this.selectedNews,
      forumId: this.forumId
    }).subscribe((response: any) => {
      this.modalService.dismissAll();
      this.initNews()
      this.initNewsByForumId()
      this.toastr.success('News added to forum')
      this.cdr.detectChanges();
    })
  }

  removeNewsFromForum(newsId: any) {
    this.auth.remove_news_from_forum({
      newsId: newsId,
      forumId: this.forumId
    }).subscribe((response: any) => {
      this.initNewsByForumId()
      this.toastr.success('News removed from forum')
      this.cdr.detectChanges();
    })
  }
  removeHtmlTags(text: string): string {
    return text ? text.replace(/<[^>]*>/g, "") : "";
  }
  formatText(text: string, length?: number): string {
    const cleanText = this.removeHtmlTags(text);
    return cleanText;
  }

  shortText(cleanText: string, length: number) {
    return cleanText.length > length ? cleanText.substr(0, length) + '...' : cleanText;
  }

  convertDate(value: number) {
    let date = value;

    return moment.unix(value).format("MMMM D, YYYY");
  }
}